import React from 'react';
import { RobotOutlined, ArrowRightOutlined, LoadingOutlined } from '@ant-design/icons';
import { useAgentMatcher } from '../../hooks/useAgentMatcher';
import {
  AgentFinder as AgentFinder__Root,
  AgentFinder__Header,
  AgentFinder__Subtext,
  AgentFinder__InputRow,
  AgentFinder__Input,
  AgentFinder__Button,
  AgentFinder__Result,
  AgentFinder__Reason,
  AgentFinder__AgentLink,
  AgentFinder__Error,
} from './AgentFinder.styles';

export const AgentFinder: React.FC = () => {
  const { query, setQuery, loading, result, error, search, selectAgent } =
    useAgentMatcher();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    search();
  };

  return (
    <AgentFinder__Root>
      <AgentFinder__Header>
        <RobotOutlined /> Master Assistant
      </AgentFinder__Header>

      <AgentFinder__Subtext>
        I can help you find the right buddy to ask your question.
        Describe what you need and I&apos;ll point you to the best agent.
      </AgentFinder__Subtext>

      <AgentFinder__InputRow onSubmit={handleSubmit}>
        <AgentFinder__Input
          type="text"
          placeholder="e.g. I need help with a purchase order…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          disabled={loading}
        />
        <AgentFinder__Button type="submit" disabled={loading || !query.trim()}>
          {loading ? <LoadingOutlined /> : 'Find'}
        </AgentFinder__Button>
      </AgentFinder__InputRow>

      {result && (
        <AgentFinder__Result>
          <AgentFinder__Reason>{result.reason}</AgentFinder__Reason>
          <AgentFinder__AgentLink
            type="button"
            onClick={selectAgent}
            disabled={!result.agent}
          >
            <ArrowRightOutlined />
            Open {result.agentName}
          </AgentFinder__AgentLink>
        </AgentFinder__Result>
      )}

      {error && <AgentFinder__Error>{error}</AgentFinder__Error>}
    </AgentFinder__Root>
  );
};
